//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
require('particles.js')
import config from './config/default'
import { mapActions } from 'vuex'
import { Message } from 'element-ui'
// import admin from"../../router/admin.js"
export default {
  data () {
    let mobile = ''
    let pwd = ''
    if(window.location.href.indexOf('192.168.16.46')>-1){
      mobile = '18202810184'
      pwd = '123456'
    }
    if (window.location.href.indexOf('localhost')>-1) {
      mobile = '18200000001'
      pwd = '123456'
    }
    if (window.location.href.indexOf('doc.')>-1
      && window.location.href.indexOf('index.html')>-1) {
      mobile = '18200000000'
      pwd = '123456'
    }
    return {
      // 表单
      formLogin: {
        mobile: mobile,
        pwd: pwd
      },
      // 校验
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // 初始化例子插件
    particlesJS('login', config)
    console.log(this.$router.options.routes)
  },
  methods: {
    ...mapActions([
      'd2adminLogin'
    ]),
    /**
     * @description 提交表单
     */
    // 提交登陆信息
    submit () {


      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 登陆
          this.d2adminLogin({
            vm: this,
            mobile: this.formLogin.mobile,
            pwd: this.formLogin.pwd
          })
        } else {
          // 登陆表单校验失败
          this.$message.error('表单校验失败')
        }
      })
    }
  }
}
